export default __webpack_public_path__ + "static/media/outline_dark_middile.2b06d31f.png";